import React from "react"
import PropTypes from "prop-types"
const Ornament = "https://bawamasalacompany.com/assets/images/Elements/Ornament.png"

export const Heading = ({ title }) => {
	return (
		<h1 className="global__heading">
			{title}
			<div className="ornament">
				<img src={Ornament} alt="header ornament" className="" />
			</div>
		</h1>)
}

Heading.propTypes = {
	title: PropTypes.string
}
export default Heading



// WEBPACK FOOTER //
// ./src/components/Heading.js